import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { apiUrl } from '../config/api';
import { ResultsEnhanced } from './Results-Enhanced';
import { ScanResult } from '../types';

export function ScanViewer() {
  const { scanId } = useParams<{ scanId: string }>();
  const navigate = useNavigate();
  const [result, setResult] = useState<ScanResult | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!scanId) return;

    const fetchScan = async () => {
      try {
        const response = await fetch(apiUrl(`/scans/${scanId}`), { credentials: 'include' });
        
        if (!response.ok) {
          throw new Error('Scan not found');
        }

        const data = await response.json();
        setResult(data.result);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to load scan');
      } finally {
        setLoading(false);
      }
    };

    fetchScan();
  }, [scanId]);

  if (loading) {
    return (
      <div style={{ padding: '40px', textAlign: 'center' }}>
        <h2>Loading scan...</h2>
      </div>
    );
  }

  if (error || !result) {
    return (
      <div style={{ padding: '40px', textAlign: 'center' }}>
        <h2>Scan not found</h2>
        <p>{error || 'The scan you requested could not be found.'}</p>
        <button onClick={() => navigate('/')} style={{ marginTop: '20px' }}>
          Back to Upload
        </button>
      </div>
    );
  }

  return <ResultsEnhanced result={result} onReset={() => navigate('/')} />;
}
